// API timestamps are New York wall time with no offset ("2026-10-12T14:05:00"). Read them as UTC
// and format in UTC so the stored Eastern time shows exactly, whatever the viewer's own timezone.
// Strings that do carry an offset/Z are real instants and get converted to New York.
const hasOffset = (value) => /(Z|[+-]\d{2}:?\d{2})$/i.test(value);

export const formatEastern = (dateString, options) => {
    if (!dateString) return '';
    const value = String(dateString);
    const offsetPresent = hasOffset(value);
    const asUtc = offsetPresent ? value : `${value}${value.includes('T') ? '' : 'T00:00:00'}Z`;
    const date = new Date(asUtc);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', { ...options, timeZone: offsetPresent ? 'America/New_York' : 'UTC' }).format(date);
};
